import { StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { useTheme } from "react-native-elements";
import { getPrimaryButtonTextColor } from "./Miscellaneous";

export function ActiveMark(props: {
  disabled: boolean;
  style?: StyleProp<ViewStyle>;
}) {
  const theme = useTheme();
  const color = getPrimaryButtonTextColor(theme.theme, props.disabled);
  return (
    <View
      style={[styles.activeMark, { backgroundColor: color }, props?.style]}
    />
  );
}

const styles = StyleSheet.create({
  activeMark: {
    width: 8,
    height: 8,
    alignSelf: "center",
    marginRight: 8,
    borderRadius: 4,
  },
});
